export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új védőoltás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveAndPrint'
            }
        ],
        rowActions: [
            // {
            //     btn_text: '<i class="fas fa-print"></i>',
            //     title: 'Nyomtatás',
            //     event_name: "customClick",
            //     class: "btn btn-outline-success",
            //     event_payload: 'printRow'
            // },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            // {
            //     btn_text: '<i class="fas fa-undo"></i>',
            //     title: 'Visszaállítás',
            //     event_name: "customClick",
            //     class: "btn btn-outline-warning",
            //     seeCaseOfDeleted: true,
            //     event_payload: 'unDeleteRow'
            // }
        ],
        headerFields: [
            {
                name: "id",
                label: "id",
                visibility: false
            },
            {
                name: "vaccinationId",
                label: "Védőoltás azonosító",
                visibility: false
            },
            {
                name: "vaccinationType",
                label: "Oltás típusa",
                visibility: true
            },
            {
                name: "medicationName",
                label: "Gyógyszernév",
                visibility: true 
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false
            },
            {
                name: "dateOfVaccination",
                label: "Oltás dátuma",
                slot_name: "startDate_format",
                visibility: true,
                formType: "date"
            },
            {
                name: "nextDoseDate",
                label: "Következő oltás dátuma",
                slot_name: "date_format",
                formType: "date",
                sort: true,
                visibility: true
            },
            {
                name: "vaccinationNumber",
                label: "Oltóanyag száma",
                visibility: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "rejected",
                label: "Visszautasítva",
                visibility: false
            },
            // {
            //     name: "nextDoseReq",
            //     label: "Következő oltás kötelező",
            //     visibility: true
            // },
            
            {
                name: "comment",
                label: "comment",
                visibility: false
            },
            {
                name: "prescribedByTheEmployer",
                label: "Munkáltató által felírva",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: true
            }
        ]
    }
}
